var map = {
	"./Approved.svg": 3762,
	"./AwaitingParts.svg": 3763,
	"./Closed.svg": 3764,
	"./Completed.svg": 3765,
	"./Excel.svg": 3766,
	"./Exportall_grey.svg": 3767,
	"./Exportall_grey_circle.svg": 3768,
	"./InProgress.svg": 3769,
	"./New.svg": 3770,
	"./View_Pic_Grey.svg": 3771,
	"./accident.svg": 3772,
	"./account.svg": 3773,
	"./addOrange.svg": 3774,
	"./addUser.svg": 3775,
	"./addVehicle.svg": 3776,
	"./address.svg": 3777,
	"./alert.svg": 3778,
	"./all_active.svg": 3779,
	"./all_active_es.svg": 3780,
	"./arrow-down.svg": 3781,
	"./arrow-up.svg": 3782,
	"./arrowRight.svg": 3783,
	"./awaiting_parts_grey.svg": 3784,
	"./awaiting_parts_orange.svg": 3785,
	"./back-btn.svg": 3786,
	"./back-button-grey.svg": 3787,
	"./backButton.svg": 3788,
	"./bills_of_landing_active.svg": 3789,
	"./bills_of_landing_active_es.svg": 3790,
	"./bobTail.svg": 3791,
	"./book-solid.svg": 3792,
	"./boxTruck.svg": 3793,
	"./calanderIcon.svg": 3794,
	"./cameraSelected.svg": 3795,
	"./camera_selected.svg": 3796,
	"./chat-icon.svg": 3797,
	"./circle-Exportall_grey.svg": 3798,
	"./circle-export.svg": 3799,
	"./circle-exportUser.svg": 3800,
	"./circle-import.svg": 3801,
	"./circle-importUser.svg": 3802,
	"./circle-viewall.svg": 3803,
	"./clearAll.svg": 3804,
	"./close-popup.svg": 3805,
	"./closeMap.svg": 3806,
	"./closed-Orange.svg": 3807,
	"./closed-grey.svg": 3808,
	"./clusterIcon.svg": 3809,
	"./communication_records_active.svg": 3810,
	"./communication_records_active_es.svg": 3811,
	"./company.svg": 3812,
	"./companyIcon.svg": 3813,
	"./complete-Orange.svg": 3814,
	"./complete-grey.svg": 3815,
	"./csa.svg": 3816,
	"./csaSnapshot.svg": 3817,
	"./dailyDocuments.svg": 3818,
	"./dashboard.svg": 3819,
	"./dashboardIcon.svg": 3820,
	"./date.svg": 3821,
	"./delete.svg": 3822,
	"./deleteCircle.svg": 3823,
	"./delivery_receipts_active.svg": 3824,
	"./delivery_receipts_active_es.svg": 3825,
	"./departments.svg": 3826,
	"./departmetEdit.svg": 3827,
	"./developer.svg": 3828,
	"./direction.svg": 3829,
	"./dispatch_records_active.svg": 3830,
	"./dispatch_records_active_es.svg": 3831,
	"./document.svg": 3832,
	"./documents.svg": 3833,
	"./dot.svg": 3834,
	"./dotAudit.svg": 3835,
	"./dotauditIcon.svg": 3836,
	"./downarrowIcon.svg": 3837,
	"./download.svg": 3838,
	"./downloadCenter.svg": 3839,
	"./downloadCenterMenu.svg": 3840,
	"./driver-behaviour.svg": 3841,
	"./driver.svg": 3842,
	"./dryVan.svg": 3843,
	"./dtc.svg": 3844,
	"./dualCam.svg": 3845,
	"./dump.svg": 3846,
	"./edit.svg": 3847,
	"./editLogIcon.svg": 3848,
	"./editSvg.svg": 3849,
	"./en.svg": 3850,
	"./es.svg": 3851,
	"./excelNew.svg": 3852,
	"./export-grey.svg": 3853,
	"./export.svg": 3854,
	"./exportUser.svg": 3855,
	"./feedback.svg": 3856,
	"./file-pdf-regular.svg": 3857,
	"./filter.svg": 3858,
	"./flatBed.svg": 3859,
	"./fleet.svg": 3860,
	"./fleetCompanies.svg": 3861,
	"./fleetdriverIcon.svg": 3862,
	"./fleetvehiclesIcon.svg": 3863,
	"./fletBed.svg": 3864,
	"./fuel.svg": 3865,
	"./full.svg": 3866,
	"./hamburger.svg": 3867,
	"./help-icon.svg": 3868,
	"./historyLogs.svg": 3869,
	"./icon-delete.svg": 3870,
	"./icon-export.svg": 3871,
	"./icon-menu-logs.svg": 3872,
	"./ifta.svg": 3873,
	"./import.svg": 3874,
	"./importUser.svg": 3875,
	"./in_progress_grey.svg": 3876,
	"./in_progress_orange.svg": 3877,
	"./infoTruck.svg": 3878,
	"./inspection-dvir.svg": 3879,
	"./inspection.svg": 3880,
	"./key.svg": 3881,
	"./leftArrow.svg": 3882,
	"./location.svg": 3883,
	"./locationMap.svg": 3884,
	"./log.svg": 3885,
	"./logEdit.svg": 3886,
	"./logHistory.svg": 3887,
	"./logoutIcon.svg": 3888,
	"./logs.svg": 3889,
	"./logsIcon.svg": 3890,
	"./mack.svg": 3891,
	"./mail.svg": 3892,
	"./main_camera.svg": 3893,
	"./mappinPopup.svg": 3894,
	"./menu_companies.svg": 3895,
	"./menu_dailyLog.svg": 3896,
	"./menu_reports.svg": 3897,
	"./menu_reseller.svg": 3898,
	"./menu_vehicle.svg": 3899,
	"./messageSender.svg": 3900,
	"./messaging.svg": 3901,
	"./new_login.svg": 3902,
	"./ninePin.svg": 3903,
	"./nonEdit.svg": 3904,
	"./notFull.svg": 3905,
	"./not_started_grey.svg": 3906,
	"./not_started_orange.svg": 3907,
	"./otherTrailer.svg": 3908,
	"./otherTruck.svg": 3909,
	"./other_documents_active.svg": 3910,
	"./other_documents_active_es.svg": 3911,
	"./overview.svg": 3912,
	"./page-first.svg": 3913,
	"./page-last.svg": 3914,
	"./page-next.svg": 3915,
	"./page-prev.svg": 3916,
	"./phone.svg": 3917,
	"./pickup.svg": 3918,
	"./pneumaticTrailer.svg": 3919,
	"./policy.svg": 3920,
	"./popupClose.svg": 3921,
	"./popupConfirm.svg": 3922,
	"./popupDelete.svg": 3923,
	"./privatePassenger.svg": 3924,
	"./qbdii.svg": 3925,
	"./receipts_active.svg": 3926,
	"./receipts_active_es.svg": 3927,
	"./reeferTrailer.svg": 3928,
	"./refreshCircle.svg": 3929,
	"./renewal.svg": 3930,
	"./repair.svg": 3931,
	"./reportIcon.svg": 3932,
	"./reports.svg": 3933,
	"./save-regular.svg": 3934,
	"./scoreCard.svg": 3935,
	"./searchGrey.svg": 3936,
	"./selectedConnection.svg": 3937,
	"./share.svg": 3938,
	"./sixPin.svg": 3939,
	"./sort.svg": 3940,
	"./speedometer.svg": 3941,
	"./spotlightGreen.svg": 3942,
	"./spotlightGrey.svg": 3943,
	"./spotlightRed.svg": 3944,
	"./straightTruck.svg": 3945,
	"./supportIcon.svg": 3946,
	"./switch.svg": 3947,
	"./tankerTrailer.svg": 3948,
	"./tick.svg": 3949,
	"./time.svg": 3950,
	"./timePicker.svg": 3951,
	"./toggle-off.svg": 3952,
	"./toggle-on.svg": 3953,
	"./tools.svg": 3954,
	"./tractorDayCab.svg": 3955,
	"./tractorSleeper.svg": 3956,
	"./undelete.svg": 3957,
	"./unsaved.svg": 3958,
	"./update.svg": 3959,
	"./upload.svg": 3960,
	"./usdot.svg": 3961,
	"./user.svg": 3962,
	"./userprofileIcon.svg": 3963,
	"./users.svg": 3964,
	"./vacuumTrailer.svg": 3965,
	"./vacuumTruck.svg": 3966,
	"./van.svg": 3967,
	"./vehicle-behaviour.svg": 3968,
	"./vehicle.svg": 3969,
	"./vehicleIcon.svg": 3970,
	"./viewArrow.svg": 3971,
	"./viewDocument.svg": 3972,
	"./viewReports.svg": 3973,
	"./viewStatus.svg": 3974,
	"./viewallMap.svg": 3975,
	"./violation.svg": 3976,
	"./volvo.svg": 3977,
	"./weigh_tickets_active.svg": 3978,
	"./weigh_tickets_active_es.svg": 3979,
	"./whitecheck_new.svg": 3980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3761;